import React from 'react';
import { Loading } from './styles';

const LoadingCommon = () => (
  <Loading size={24} color="inherit" />
);
export default LoadingCommon;
